import type { SVGProps } from "react";
export interface Bridge01IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Bridge01Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Bridge01IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 11V7.007a5.1 5.1 0 0 1-2.25-1.125V11a1.125 1.125 0 0 1-2.25 0V5.882a5.1 5.1 0 0 1-2.25 1.125V11a1.125 1.125 0 0 1-2.25 0V7.007a5.1 5.1 0 0 1-2.25-1.125V11a1.125 1.125 0 0 1-2.25 0V5.882a5.1 5.1 0 0 1-2.25 1.125V11a1.125 1.125 0 0 1-2.25 0V7.118A1.125 1.125 0 0 1 2 4.875h1c1.247 0 2.07-.69 2.636-1.513a5.9 5.9 0 0 0 .769-1.62l.004-.017v.001a1.125 1.125 0 0 1 2.181 0l.006.016.028.094a5.9 5.9 0 0 0 .741 1.526c.566.823 1.388 1.513 2.636 1.513 1.246 0 2.069-.69 2.635-1.513a5.9 5.9 0 0 0 .769-1.62l.004-.017v.001a1.125 1.125 0 0 1 2.181 0l.006.016.028.094a5.9 5.9 0 0 0 .741 1.526c.566.823 1.388 1.513 2.635 1.513h1l.115.006a1.125 1.125 0 0 1 .01 2.236V11a1.125 1.125 0 0 1-2.25 0"
      />
      <path
        fill={color}
        d="M20.125 20.875h.75v-8.75H3.125v8.75h.75V17.5a3.625 3.625 0 0 1 7.25 0v3.375h1.75V17.5a3.625 3.625 0 0 1 7.25 0zm3 .625c0 .898-.727 1.625-1.625 1.625h-2a1.625 1.625 0 0 1-1.625-1.625v-4a1.374 1.374 0 0 0-2.75 0v4c0 .897-.727 1.624-1.624 1.625h-3A1.625 1.625 0 0 1 8.875 21.5v-4a1.374 1.374 0 0 0-2.75 0v4c0 .897-.727 1.624-1.625 1.625h-2A1.625 1.625 0 0 1 .875 21.5V12c0-1.173.952-2.125 2.125-2.125h18c1.174 0 2.125.952 2.125 2.126z"
      />
    </svg>
  );
}
